import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
// 引入rem适配
import './utils/rem.js'
// 引入路由配置
import router from './router'
// 引入vant组件库
import Vant from 'vant'
import 'vant/lib/index.css'
// 引入axios配置
import axios from './utils/axios.js'

const app = createApp(App)
// 使用路由
app.use(router)
// 使用vant组件库
app.use(Vant)
// 将axios挂载到Vue实例
app.config.globalProperties.$axios = axios
app.mount('#app')
